export default "__VITE_ASSET__DI6LR82W__"